export default "__VITE_ASSET__BzeyhIc3__"